'use client';

import { useGamesList } from '@shared/hooks';
import { InnerPageContainer } from '../../../../InnerPageContainer/InnerPageContainer';
import { TermsAndConditions } from '../../../components/TermsAndConditions/TermsAndConditions';
import { Accordion } from '../../components/Accordion';
import { CRMContent } from '../../components/CRMContent';
import { CRMHeader } from '../../components/CRMHeader';
import { GamePods } from '../../components/GamePods';
import type { MultiofferLandingPageData } from './types.ts';

type MultiofferLandingPageProps = {
  landingPageData: MultiofferLandingPageData;
};

function MultiofferLandingPage({ landingPageData }: MultiofferLandingPageProps): React.JSX.Element {
  const { games: allGames } = useGamesList();
  const { list } = landingPageData;
  const { heading, image, pods, accordions, subheading, description, tags, termsAndConditions, validUntil: validUntilDate } = list[0]!;
  const filteredGames = allGames.filter(game => pods?.some(pod => pod.gameId?.toLowerCase() === game?.name?.toLowerCase()));

  const trackingAttributes = {
    'data-track-container': 'Offer',
    'data-track-product': 'Games',
    'data-track-name': heading,
    'data-track-type': 'No Opt In',
    'data-track-expiration-date': validUntilDate,
  };

  return (
    <InnerPageContainer {...trackingAttributes}>
      {image?.link && <CRMHeader image={image} />}

      <div className="ll-grid-container gap-y-4 pt-5 pb-8 sm-md:[--ll-container-padding:40px]">
        <CRMContent title={heading} subheading={subheading || description} validUntilDate={validUntilDate} callout={tags?.callout} sectionClassName="ll-container-inner">
          <GamePods pods={pods} games={filteredGames} sectionClassName="ll-container-inner" />
        </CRMContent>

        <Accordion items={accordions} isTermsAndConditions={Boolean(termsAndConditions)} isCallToAction={pods?.length > 0} />

        {termsAndConditions && (
          <section className="ll-container-inner flex flex-col items-start pb-16 md:pb-0 mt-6 md:mt-8">
            <TermsAndConditions information={termsAndConditions} isSmallText={true} />
          </section>
        )}
      </div>
    </InnerPageContainer>
  );
}

export { MultiofferLandingPage };
